import { getCurrentUser } from './auth';
const KEY = 'my_blog_posts_v1';

function uid() {
  return Date.now().toString(36) + Math.random().toString(36).slice(2, 7);
}

export function getPosts() {
  const raw = localStorage.getItem(KEY);
  if (!raw) return [];
  try {
    return JSON.parse(raw).sort((a, b) => b.createdAt - a.createdAt);
  } catch (e) {
    return [];
  }
}

export function getPostById(id) {
  return getPosts().find(p => p.id === id);
}

export function savePost({ title, content }) {
  const posts = getPosts();
  const user = getCurrentUser();
  const post = { id: uid(), title, content, createdAt: Date.now(), author: user?.username || null };
  posts.push(post);
  localStorage.setItem(KEY, JSON.stringify(posts));
  try { window.dispatchEvent(new Event('storage')); } catch (e) {}
  return post.id;
}

export function updatePost(id, { title, content }) {
  const posts = getPosts();
  const idx = posts.findIndex(p => p.id === id);
  if (idx === -1) return false;
  // only allow owner to update
  const user = getCurrentUser();
  if (!user || user.username !== posts[idx].author) return false;
  posts[idx] = { ...posts[idx], title, content, updatedAt: Date.now() };
  localStorage.setItem(KEY, JSON.stringify(posts));
  try { window.dispatchEvent(new Event('storage')); } catch (e) {}
  return true;
}

export function deletePost(id) {
  const posts = getPosts();
  const idx = posts.findIndex(p => p.id === id);
  if (idx === -1) return false;
  // only allow owner to delete
  const user = getCurrentUser();
  if (!user || user.username !== posts[idx].author) return false;
  const remaining = posts.filter(p => p.id !== id);
  localStorage.setItem(KEY, JSON.stringify(remaining));
  try { window.dispatchEvent(new Event('storage')); } catch (e) {}
  return true;
}
export function exportPosts() {
  return getPosts();
}

export function importPosts(postsArray, { merge = true } = {}) {
  if (!Array.isArray(postsArray)) return { ok: false, error: 'invalid data' };
  const existing = getPosts();
  let merged;
  if (merge) {
    const map = new Map(existing.map(p => [p.id, p]));
    postsArray.forEach(p => {
      if (!map.has(p.id)) map.set(p.id, p);
    });
    merged = Array.from(map.values());
  } else {
    merged = postsArray;
  }
  localStorage.setItem(KEY, JSON.stringify(merged));
  try { window.dispatchEvent(new Event('storage')); } catch (e) {}
  return { ok: true, count: merged.length };
}

